import { render, staticRenderFns } from "./VolunteerCardNet.vue?vue&type=template&id=0fb52223"
import script from "./VolunteerCardNet.vue?vue&type=script&lang=ts"
export * from "./VolunteerCardNet.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerCardNet.vue?vue&type=style&index=0&id=0fb52223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports